export * from './dados-de-cobranca.component';
